<template>
  <div>
    <ContentHeading :heading="heading" />
    <ContentList
      :contents="content"
      :tenant-url="tenantUrl"
      :parent-group-id="parentGroupId"
      :is-desktop="isDesktop"
    />
  </div>
</template>

<script>
import ContentHeading from './ContentHeading.vue';
import ContentList from './ContentList.vue';

export default {
  components: {
    ContentHeading,
    ContentList,
  },
  props: {
    heading: {
      type: String,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    tenantUrl: {
      type: String,
      required: true,
    },
    parentGroupId: {
      type: Number,
      required: true,
    },
    isDesktop: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
